











































import Vue from 'vue';

export default Vue.extend({
	props: {
		outro: {
			type: Boolean,
			default: false,
		},
		openExternal: {
			type: Boolean,
			default: false,
		},
	},
});
